/* eslint-disable import/prefer-default-export */
import { FetchedPatientFragment } from '../../api/queries/__generated__/patient.gql'
import { CountryBirthError, InsNumError, PartialRecord } from '../../utils/types'
import { PatientFieldErrorMessage, PatientPageError } from './Form/_props'

export const patientFormErrors: PartialRecord<keyof FetchedPatientFragment, Partial<PatientFieldErrorMessage>> = {
    insNum: {
        required: "Le Matricule INS est obligatoire et n'a pas été renseigné",
        minLength: 'Le matricule INS est invalide, 15 caractères sont requis',
    },
    socialSecurityNumber: {
        required: "Le numéro de sécurité sociale est obligatoire et n'a pas été renseigné",
        minLength: 'Le numéro de sécurité sociale doit comporter 15 caractères',
    },
    sex: {
        required: "Le sexe est obligatoire et n'a pas été renseigné",
    },
    birthName: {
        required: "Le nom de naissance est obligatoire et n'a pas été renseigné",
    },
    firstNameList: {
        required: "Le 1e prénom de naissance est obligatoire et n'a pas été renseigné",
    },
    birthDate: {
        required: "La date de naissance est obligatoire et n'a pas été renseignée",
    },
    countryBirth: {
        required: "La pays de naissance est obligatoire et n'a pas été renseignée",
    },
    birthCityLabel: {
        required: "Le lieu de naissance est obligatoire et n'a pas été renseigné",
    },
    insuredSsn: {
        required: "Le numéro de sécurité sociale de l'assuré (si ayant droit) est obligatoire et n'a pas été renseigné",
        minLength: "Le numéro de sécurité sociale de l'assuré (si ayant droit) doit comporter 15 caractères",
    },
    patientInsuredUserLabel: {
        required: "Le nom et prénom de l'assuré est obligatoire et n'a pas été renseigné",
    },
}

export const patientFormInsNumErrors: Record<InsNumError, string> = {
    birthYearMismatch: "L'année renseignée dans la date ne correspond pas à l'année liée à l'INS",
    birthMonthMismatch: "Le mois renseigné dans la date ne correspond pas au mois lié à l'INS",
    NirKey: 'La clé NIR est incorrecte',
    NirKeySearch: 'La clé de contrôle (deux derniers caractères) du matricule INS est incomplète ou invalide',
    incorrectBirthYear: "L'année de naissance est incorrecte",
    sex: "Le sexe indiqué ne correspond pas au sexe lié à l'INS",
    departmentCode: 'Le code département indiqué dans le numéro de sécurité sociale est incorrect',
}
export const patientFormCountryBirthErrors: Record<CountryBirthError, string> = {
    required: "Le pays de naissance est obligatoire et n'est pas renseigné",
    ssnMismatched: "Le pays de naissance renseigné ne correspond pas à celui lié à l'INS",
}

export const patientPageErrors: Record<PatientPageError, string> = {
    patientDoesNotExists: "Erreur: ce patient n'existe pas",
    patientCreationForbidden: "La création de patients n'est pas disponible pour cet établissement",
    unknownError:
        'Une erreur est survenue, vous pouvez recharger la fiche patient ou retourner à la liste des patients.',
}
